function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.8 255.1L33.3 178.4C13.5 162.3 1.7 140.2.2 116.1c-1.4-22.4 6.2-44.2 21-59.7 13.9-14.6 33.3-22.6 54.6-22.8h.6c20.9 0 41.3 7.7 57.6 21.7l7.8 6.4 7.8-6.4c16.4-14.1 37-21.8 58.1-21.7 21.3.1 40.7 8.2 54.6 22.8 14.8 15.5 22.5 37.3 21.1 59.7-1.5 24.1-13.3 46.2-33.1 62.2l-.8.6-107.7 76.2zm-91-99l91 64.3 91-64.3c13.4-11 21.3-25.8 22.3-41.8.9-14.6-3.9-28.5-13.3-38.4C223.6 57 190.5 57.5 168 77l-.3.2-25.9 21.2L115.5 77c-22.6-19.6-55.7-20-73.8-1-9.4 9.8-14.2 23.8-13.3 38.3 1.1 16 9 30.8 22.4 41.8z",
  id: "Life_events"
})));